import React from 'react';
import { Zap, ShieldCheck, Headphones, TrendingUp, Clock, Users } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';

export default function WhyChooseUs() {
  const { t } = useLang();
  const reasons = [
    { icon: Zap, title: t.why.r1, description: t.why.r1d },
    { icon: ShieldCheck, title: t.why.r2, description: t.why.r2d },
    { icon: Headphones, title: t.why.r3, description: t.why.r3d },
    { icon: TrendingUp, title: t.why.r4, description: t.why.r4d },
    { icon: Clock, title: t.why.r5, description: t.why.r5d },
    { icon: Users, title: t.why.r6, description: t.why.r6d },
  ];

  return (
    <section id="pourquoi" data-testid="why-section" className="py-24 md:py-32 bg-white relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#00D186] mb-4 block">{t.why.label}</span>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-tight text-[#0B132B] mb-6">{t.why.title1}{' '}<span className="text-gradient">{t.why.title2}</span></h2>
            <p className="text-base text-[#475569] leading-relaxed mb-8">{t.why.desc}</p>
            <div className="p-8 rounded-xl bg-[#0B132B] text-white">
              <p className="text-lg font-light italic leading-relaxed text-white/80 mb-4">{t.why.quote}</p>
              <p className="text-[#00D186] font-bold text-sm">— GIT NFT GHANA LTD</p>
            </div>
          </div>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {reasons.map((reason, i) => (
              <div key={i} data-testid={`why-reason-${i}`} className="p-6 rounded-xl border border-[#E2E8F0] bg-[#F3F5F7] transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-[#00D186]/30 group">
                <div className="w-12 h-12 rounded-lg bg-[#0B132B] flex items-center justify-center mb-4 group-hover:bg-[#00D186] transition-colors duration-300">
                  <reason.icon size={22} className="text-[#00D186] group-hover:text-[#0B132B] transition-colors duration-300" />
                </div>
                <h3 className="text-lg font-bold text-[#0B132B] mb-2">{reason.title}</h3>
                <p className="text-sm text-[#475569] leading-relaxed">{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
